import Vue from 'vue'
import Participate from './Participate'
import ParticipateResultTest from './TestParticipationResult'
import Profile from './Profile'
import CampaignListMap from './CampaignListMap'
import CampaignMap from './CampaignMap'
import ApiClients from './plugins/ApiClients.js'
import CampaignImages from './CampaignImages'
import CMSCarousel from './CMSCarousel';
import MissingTerms from './Terms';
import store from './store'
import i18next from 'i18next';
import VueI18Next from '@panter/vue-i18next';
import CircularCountDownTimer from "vue-circular-count-down-timer";
import VueGtag from "vue-gtag";

Vue.use(CircularCountDownTimer);
Vue.config.productionTip = false

Vue.use(VueGtag, {
  config: { id: "UA-53353386-2" }, // hardcoded for now
  bootstrap: false
});

const config = document.getElementById('app-config');
let language = 'en';
if (config) {
  Vue.use(ApiClients, {
    userApiUrl: config.dataset.userApiUrl,
    frontendApiUrl: config.dataset.frontendApiUrl,
    accessToken: config.dataset.accessToken,
    appName: config.dataset.appName,
  });

  if (config.dataset.language) {
    language = config.dataset.language;
  }
}

Vue.use(VueI18Next);
import de from '@/l10n/de';
import en from '@/l10n/en';
import { format, parseISO } from "date-fns";

const locale = 'de'; // TODO get from config/browser
i18next.init({
  lng: language,
  resources: {
    de: { translation: de.de },
    en: { translation: en.en }
  },
  interpolation: {
    format: function(value, i18nFormat) {
      // param lng not used
      if (i18nFormat === "NUMBER") {
        return Intl.NumberFormat(locale, {
          style: "decimal"
        }).format(value);
      }
      if (i18nFormat === "DATETIME") {
        if (!(value instanceof Date)) {
          value = parseISO(value);
        }
        let dateFormat = "dd.MM.yyyy 'um' HH:mm";
        return format(value, dateFormat);
      }
      return value;
    }
  }
})
const i18n = new VueI18Next(i18next);

const participation = document.getElementById('participation');
if (participation) {
  new Vue({
    render: h => h(Participate),
    store,
    i18n,
    data: () => Object.assign({},{
      campaignIdent: participation.dataset.campaignIdent,
      campaignTitle: participation.dataset.campaignTitle,
      autoParticipate: participation.dataset.autoparticipate || false,
      merchantImage: participation.dataset.merchantImage,
      moreCampaigns: participation.dataset.moreCampaigns,
      closable: participation.dataset.closable || true,
      googleApiKey: config.dataset.googleApiKey})
  }).$mount(participation)
}

const missingTerms = document.getElementById('missingTerms');
if (missingTerms) {
  new Vue({
    render: h => h(MissingTerms),
    store,
    i18n,
    data: () => Object.assign({},{
      missingTermIdents: missingTerms.dataset.missingTermsIdents.split(';'),
    })
  }).$mount(missingTerms)
}

const profile = document.getElementById('profile');
const profileConfig = document.getElementById('profile-config')
if (profile) {
  new Vue({
    render: h => h(Profile),
    store,
    i18n,
    data: () => Object.assign({},{
      googleApiKey: config.dataset.googleApiKey,
      continue_uri: profileConfig.dataset.continueUri
    }) ,
  }).$mount(profile)
}

const campaignListMap = document.getElementById('campaign-list-map');
const geolocConfig = document.getElementById('geoloc-config');
if (campaignListMap && geolocConfig) {
  new Vue({
    render: h => h(CampaignListMap),
    store,
    i18n,
    data: () => Object.assign({},{
      googleApiKey: config.dataset.googleApiKey,
      locLat: parseFloat(geolocConfig.dataset.locLat),
      locLng: parseFloat(geolocConfig.dataset.locLng),
      locQuality: geolocConfig.dataset.locQuality
    }) ,
  }).$mount(campaignListMap)
}

const campaignImageGallery = document.getElementById('campaign-image-gallery');
if (campaignImageGallery) {
  new Vue({
    render: h => h(CampaignImages),
    store,
    i18n,
    data: () => Object.assign({}, {
      campaignIdent: campaignImageGallery.dataset.uuid
    }),
  }).$mount(campaignImageGallery)
}

const campaignMap = document.getElementById('campaign-map');
if (campaignMap && geolocConfig) {
  new Vue({
    render: h => h(CampaignMap),
    store,
    i18n,
    data: () => Object.assign({},{
      googleApiKey: config.dataset.googleApiKey,
      locLat: parseFloat(geolocConfig.dataset.locLat),
      locLng: parseFloat(geolocConfig.dataset.locLng),
      locQuality: geolocConfig.dataset.locQuality,
      campaignIdent: campaignMap.dataset.campaign,
      showList: campaignMap.dataset.showList
    }) ,
  }).$mount(campaignMap)
}

const participationResultTest = document.getElementById('participation-result-test');
if (participationResultTest) {
  new Vue({
    render: h => h(ParticipateResultTest),
    store,
    i18n,
  }).$mount(participationResultTest)
}

const cmsCarousel = document.getElementById('cms-carousel');
if (cmsCarousel) {
  new Vue({
    render: h => h(CMSCarousel),
    store,
    i18n,
    data: () => Object.assign({},{
      elements: JSON.parse(cmsCarousel.dataset.elements)
    }),
  }).$mount(cmsCarousel);
}
